import React, { useEffect } from "react";
import { useFormContext } from "../Form/FormContext";

interface FormDataSaverProps {
  storageKey: string;
  debounceMs?: number;
}

const FormDataSaver: React.FC<FormDataSaverProps> = ({
  storageKey,
  debounceMs = 500,
}) => {
  const { formData } = useFormContext();

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      // Save form data to sessionStorage
      sessionStorage.setItem(storageKey, JSON.stringify(formData));
    }, debounceMs);

    return () => clearTimeout(timeoutId);
  }, [formData, storageKey, debounceMs]);

  return null;
};

export default FormDataSaver;
